export default {
	language: 'Deutsch',//德語
	sanqi: {
		zhoushi: "Diagramm des Trends",
		biaoti: "Transaktionen mit Kryptowährung auf hochliquiden Märkten",
		xiangqing: "Die jahrelange Betriebserfahrung hat den Anwendern ein reichhaltiges, flexibles, stabiles, sicheres und zuverlässiges Handelsumfeld",
		Global: "Globales ökologisches Layout",
		Bank: "Sicherheit auf Bankebene",
		Focus: "Fokus auf Benutzererfahrung",
		Convenient: "Erleichterung der Transaktionen",
		project: "Globales Projekt-Expansions- und Operations-Management-System, mit lokalen Service-Handelszentren in vielen Ländern",
		level: "Das Finanzmarktsicherheitsteam hat in den letzten zehn Jahren mit dem Banksystem, der Steuerung des finanziellen Risikos in Echtzeit und der mehrdimensionalen Authentifizierung mehrere Garantien für die Kapitalsicherheit bereitgestellt.",
		polish: "Sorgfältig polieren Sie die Details, um die UI und Interaktion bequemer Ebene nach Ebene, und die Transaktion kann ein visueller Genuss werden",
		Android: "Unterstützen Sie den Betrieb von Android-, IOS- und Web-Terminals und steuern Sie Marktinformationen, globale Märkte und Transaktionen jederzeit und überall in Echtzeit",
		Download: "Mobiler Client und Handel jederzeit und überall frei herunterladen",
		Palm: "Palm Trading",
		Trade: "Handel jederzeit, überall",
		flow: "Mobile Erfahrung",
		Smooth: "Eine reibungslose Bedienung macht Sie angenehmer",
		Real: "Zitat in Echtzeit",
		time: "Echtzeit-Update, lassen Sie den Markttrend verstehen",
		Rapid: "Schnelle Aufladung",
		Experience: "Erleben Sie schnell und genießen Sie, was Sie wollen",
		Join: "Beginnen Sie Ihre Vertragsreise",
		Please: "Bitte geben Sie Ihr Mobiltelefon /E-Mail in das Eingabefeld unten ein, um Azbit-usa zu registrieren",
		enter: "Bitte geben Sie Ihre E-Mail oder Ihre Handy-Nummer ein",
		Register: "Register",

		regulatory:'regulatorische Lizenz',
		regulatory_info:'Uncleblock ist ein gesetzeskonformes Finanz- und Gelddienstleistungsunternehmen unter der Aufsicht von Kanadas FINTRAC (Canadian Financial Transaction and Report Analysis Center) und der US SEC (US Securities and Exchange Commission). Uncleblock wird alle anwendbaren Gesetze und Vorschriften in jeder Gerichtsbarkeit einhalten, in der es auf der Grundlage einer Finanzlizenz tätig ist. ',//
		canada:'Kanada (unter Aufsicht)',
		certnum:'regulatorische Zertifikatsnummer',
		dateissue:'Ausgabedatum',
		veriurl:'Kanadische Bestätigungs-URL',
		
		white_paper: 'weißes Papier',
	},
	song: {
		low:'Bitte geben Sie Ihr altes Passwort ein',
	    jgsxf:"Abzug von Bearbeitungsgebühren für die Vergabe von Aufträgen im Rahmen von ausdrücklichen Verträgen",
	    jgbj:"Abzug des Kapitals nach ausdrücklichem Vertrag",
	    jgks:"Schnelle Auftragsabwicklung, Schadensabwicklung",
	    jgyl:"Schneller Vertragsabschluss, Gewinnabwicklung",
	    htcz:"Aufladen des Hintergrundes",
	    htshcz:"Aufladen der Hintergrundprüfung",
	    bbhr:"Überweisung in Währungskonto",
	    bbhc:"Überweisung des Währungskontos",
	    pccl:"Veräußerung von Mitteln für geschlossene Positionen",
	    gmsxf:"Abzug der Bearbeitungsgebühr für den verknüpften Verkauf",
	    ggsxf:"Übermittlung fremdfinanzierter Transaktionen ohne Bearbeitungsgebühren",
	    ggbzj:"Übermittlung fremdfinanzierter Transaktionen ohne Marge",
	    gbdj:"Einreichung des anstehenden Kaufstopps",
	    gbkc:"Vorlage eines verbundenen Kaufabzugs",
	    gsdj:"Eintrag einfrieren",
	    gskc:"Vorlage eines verbundenen Umsatzes",
	    tbsbjs:"Fehlte der Währungsentzug, ging die Verriegelung zurück",
	    tbsbch:"Zurücknahme der Währung, Zurücknahme des Sperrkontos",
	    tbcg:"Widerruf erfolgreich",
	    gyf:"Leveraged Trading, Erhebung einer Übernachtungsgebühr",
	    gghr:"Übertragung von Fremdkonto",
	    gghc:"Übertragung von Fremdkonto",
	    tbdj:"Bewerben Sie sich auf Währungsrücknahme und Einfrieren des Restbetrags",
	    tbkc:"Antrag auf Abzug der Währung",
	    mhxh:"Verbrauch von Blinddosen",
	    mhhq:"Akquisition von Blinddosen",
	    msxf:"Abzug der Bearbeitungsgebühr für die Auftragserteilung des zweiten Vertrags",
	    mbj:"Entnehmen Sie den Auftraggeber bei der Bestellung",
	    mks:"Zweiter Vertrag, Schadensregulierung",
	    myl:"Zweiter Vertrag zum Abschluss, Gewinnabwicklung",
	    mhr:"Übertragung des zweiten Vertragskontos in",
	    mhc:"Überweisung des zweiten Vertragskontos",
	    sfsczj:"Abbau von Schleusen zur Erhöhung der verfügbaren Vermögenswerte",
	    sfsckc:"Freigabe des Sperrlagers Bergbau abzüglich der eingefrorenen Vermögenswerte",
	    sczj:"Bergbau in geschlossenen Lagerstätten erhöht das eingefrorene Vermögen",
	    sckc:"Abbau von vorhandenen Vermögenswerten",
	    scsy:"Einnahmen aus dem Abbau verfügbarer Vermögenswerte",
	    ahtcz:"Anmerkungen zum Laden",
	    xcbx:"Schneller Vertragsabschluss, keine effektive Versicherung, und das Kapital bleibt unverändert",
		bbjx:"Währungstransaktion: Benutzer storniert hängen und entsperren",
		bbth:"Währungstransaktion: Benutzer storniert hängende Kauf und Renditen",
		wtcd_t:"Stornierung und Rückgabe der Bearbeitungsgebühr durch die Kommission",
		wtcd_b:"Stornierung und Rückgabe der Anzahlung",
		bxju_p:"Kündigung und Ausgleichsbetrag der Versicherung",
		bxju_s:"Beendigung der Versicherung, Abzug des Versicherungsbetrags",
		bxju_b:"Beendigung der Versicherung und Abzug des Versicherungsbetrags",
	},
	iesan: {
		li_a: 'Konzentrier dich und überlass den Rest uns.',
		li_b: 'Automatisierte Anlageanalyse – entsprechend der Position-Verriegelung und dem Bergbau von Azbit-usa, kann sie die Geschäftsideen für die wichtigsten Devisenpaare der Investoren anpassen, und hoch autonome Kontoeinstellungen - passen die Vergleichsspalte des Fonds, die Vergleichsspalte der Position und die Vergleichsspalte für Frühwarnungen nach verschiedenen Kundentypen an. Achten Sie auf Händler mit unterschiedlicher Risikotoleranz auf dem Markt. Die Kreditaufnahme von Währungsreserven (Währungsleihe) der Plattform bietet die Kreditaufnahme von Reservewährungen für den gesperrten Lagerabbau. Sie können Plattformfinanzierung Kreditaufnahme nur erhalten, wenn die digitalen Vermögenswerte des Kontos 50% der Buchungsgrenze erreichen.',
		zuidi: 'Minimale',
		b_liord: "Bestellung der Blinddose",
		b_zhomg: "Blind Box gewinnen",
		b_xiaohao: "konsumieren",
		b_mangheli: "Geschenktasche für Blind Box",
		b_qingsong: "Finden Sie einfach die Super-Geschenk-Tasche",
		b_kaiqi: "Öffnen Sie die Blindbox",
		b_xuyao: "So öffnen Sie die aktuelle Blindbox",
		b_dangqian: "Laufende Bilanz",
		b_quxiao: "Stornieren",
		b_ok: "bestimmen",
		b_cuocang: "Sperren und Geld verdienen",
		b_dindan: "Bestellung der Blinddose",
		b_genduo: "Laden Sie mehr",
		b_wabao: "Schatz im Bergbau",
		b_jiandan: "Bergbau ist leichter und leicht zu erhalten",
		b_cung: "Sperren und Geld verdienen",
		b_shouyi: "Einnahmen insgesamt",
		b_zhiyao: "Menge der Verpfändung",
		b_qianbao: "Saldo der Brieftasche",
		b_goumai: "Kauf",
		b_zhjuanbi: "Sperren und Geld verdienen",
		b_num: "Menge der Einlagen",
		b_yuji: "Geschätzte Gesamteinnahmen",
		b_jin: "nahe",
		b_rinianhua: "Jährliche BezugsAnnualisierung",
		b_suochang: "Sperrzeit abgeschlossen",
		b_gtou: "Kauf",
		b_jilu: "Datensatz sperren",
		b_biaohuao: "Artikel Nr.",
		b_bizhong: "Währung",
		b_shuliang: "Menge der Einlagen",
		b_jixi: "Zinsen insgesamt",
		b_suocang: "Zeit sperren",
		b_shijan: "Dauer der Expiration",
		b_zhuangtai: "Zustand",
		b_jinxin: "haben in der Hand",
		b_jieshu: "Ist beendet",
		b_zhenqui: "Bitte geben Sie die richtige Menge ein",
		b_tian: "Tag",
		b_mei: "Nicht mehr",
		b_maghe: "Blind Box",
		b_wakuang: 'Bergbau auf Schleusen',
		levermin: "Menge ist geringer als die Mindestzahl"
	},
	chongbi: {
		zaixian:"Online Service",
		fuzhi:"Beschriftung kopieren",
		huazhuan:"Übertragung",
		bizhong:"Währung",
		keyong:"Verfügbarer Saldo",
		cong:"von",
		zhi:"zu",
		num:"Menge der Übertragung",
		shuru:"Bitte geben Sie die Transfermenge ein",
		whatsapp:"Bitte geben Sie die Kontonummer WhatsApp ein",
		youxiang:"Briefkasten",
		superior: 'Meine Untergebenen',
		tiem: 'Zeit',
		tit: 'Mein Mitglied',
		group: 'Anzahl der Teams',
		not: 'Kein Mitglied',
		qukuai: 'Die Blockkettenschule',
		fabi: 'Legale Währungstransaktion',
		gonggao: 'Mitteilung',
		xitong: 'Artikel des Systems',
		yonghu: 'Unterstützung der Benutzer',
		bangzhu: 'Hilfe Center',
		shouyi: 'Regel der Einnahmen',
		xinwen: 'News Center',
		xinshou: 'Neue Hilfe',
		jiaoyi: 'Regeln für Transaktionen',
		kuaixun: 'Nachrichtenblitz',
	},
	// 导航
	header: {
		wakuang: 'Bergbau auf Schleusen',
		miaohy: 'Vertrag über die Geschwindigkeit',
		home: 'Home Page',
		markets: 'Angebot',
		fiat: 'Legale Währungstransaktion',
		c2c: 'Transaktion C2C',
		exchange: 'Transaktion in Währung',
		lever: 'Auftragsabwicklung (Contract Transaction)',
		myshop: "Mein Laden",
		assets: 'Meine Vermögenswerte',
		help: 'Hilfe Center',
		login: "Melden Sie sich",
		sign: 'Register',
		accountSet: 'Einstellungen des Kontos',
		tradeLog: 'Logbuch der Transaktion',
		receiveSet: 'Einstellungen der Sammlung',
		identify: 'Authentifizierung der Identität',
		jchange: 'Wechselkurs der Währung',
		logout: 'Loggen Sie sich',
		themedark: 'Nachtmodus (Nachtmodus)',
		themeday: 'Tag Modus',
	},
	// 登录注册
	lg: {
		login: 'Melden Sie sich',
		register: 'Register',
	},
	// 首页
	home: {
		vol: '24h Volumen',
		c01: 'Die weltweit führende digitale Asset Trading Plattform',
		c02: 'Es bietet sichere und zuverlässige digitale Asset-Trading- und Asset-Management-Dienstleistungen für Millionen von Nutzern in mehr als 130 Ländern weltweit',
		c03: 'Sicher und zuverlässig',
		c04: '5 Jahre Erfahrung in den Finanzdienstleistungen von digitalen Vermögenswerten',
		c05: 'Professionelle verteilte Architektur und Anti DDoS Attack System',
		c06: 'Globales ökologisches Layout',
		c07: 'Local Trading Service Center wurden in vielen Ländern eingerichtet',
		c08: 'Aufbau eines Blockchain-Ökosystems, das mehrere Geschäftsmodelle integriert',
		c09: 'Benutzer zuerst',
		c10: 'Schaffung eines Mechanismus zur Vorauszahlung',
		c11: 'Einrichtung eines Investorenschutzfonds',
		c12: 'Multiplattform Terminal Transaktion jederzeit, überall',
		c13: 'Es umfasst mehrere Plattformen wie IOS, Android und Windows und unterstützt Full-Service-Funktionen',
		sweep: 'Scannen von Code Download',
		android: 'Android',
		pinput: 'Bitte geben Sie Ihre E-Mail oder Ihre Handy-Nummer ein',
		atrade: 'Registrieren Sie ein e-x globales Stationskonto, um die Transaktionsreise zu starten'
	},
	// 底部
	foo: {
		about: 'Über uns',
		support: 'Unterstützung der Benutzer',
		contact: 'Kontaktieren Sie uns',
		qq: 'Kundenservice QQ',
		email: 'Kontakt E-Mail',
	},
	// 行情
	market: {
		exchange: 'Münzen',
		selfmarket: 'Optional',
		allmarket: 'Alle Märkte',
		symbol: 'Paar Transaktionen',
		newprice: 'Aktuelle Preise',
		change: 'Erhöhung',
		highprice: 'Höchster Preis',
		lowprice: 'Mindestpreis',
		vol: '24h Volumen',
	},
	// 公共交易
	td: {
		purchase: "Der Kaufpreis",
		transaction: "Preis der Transaktion",
		service: "Service berechnen",
		profit: "Gewinn und Verlust",
		buy: 'Kauf',
		sell: 'verkaufen',
		currency: 'Währung',
		num: 'Anzahl',
		time: 'Zeit',
		limit: 'Quote',
		price: 'Preis pro Einheit',
		method: 'Methode der Zahlung',
		total: 'insgesamt',
		inwant: 'Bitte geben Sie die gewünschte',
		do: 'Betrieb',
		more: 'Laden Sie mehr',
		nomore: 'Nicht mehr',
		nodata: 'Keine Daten',
		trade: 'Transaktion',
		buynum: 'Menge des Käufes',
		sellout: 'Verkauf aus',
		buyin: 'Kauf',
		all: 'ganze',
		allbuy: 'Alle kaufen',
		allsell: 'Alle verkaufen',
		buytotal: 'Bitte geben Sie den Gesamtbetrag an',
		selltotal: 'Bitte geben Sie den Gesamtbetrag an, der verkauft werden soll',
		buyallnum: 'Bitte geben Sie die zu kaufende Menge ein',
		sellallnum: 'Bitte geben Sie die zu verkaufende Menge an',
		tradeTotal: 'Transaktionen insgesamt',
		doceil: 'Automatische Löschung in Sekunden',
		place: 'eine Bestellung aufgeben',
		waitpay: 'Bis zur Zahlung',
		paycode: 'Code der Zahlung',
		finished: 'Abgeschlossen',
		ceiled: 'Storniert',
		payed: 'Bezahlt',
		nofinish: 'hängen in der Luft',
		buyer: 'Käufer',
		seller: 'Verkäufer',
		callWay: 'Informationen zum Kontakt',
		placeTime: 'Zeit der Bestellung',
		renum: 'Nummer der Referenz',
		canceil: 'Stornieren',
		confirm: 'bestätigen',
		pwd: 'Bitte geben Sie das Transaktionspasswort ein',
		coincode: 'Die Währungseinheit',
		pcoin: 'Bitte wählen Sie eine Währungseinheit'
	},
	// 法币交易
	fat: {
		// LegalPayDetail
		orderLog: 'Datensatz der Bestellung',
		fatdLog: 'Rechtliche Währungstransaktionen',
		shoper: 'Geschäft',
		faLog: 'Rechtliche Währungstransaktionen',
		tdType: 'Art der Transaktion',
		odStatus: 'Status der Bestellung',
		pwaitPay: 'Bitte warten Sie, bis der Käufer bezahlt.',
		odFinish: 'Bestellung abgeschlossenBestellung storniert',
		odCeil: 'Die Zahlung erfolgt, bitte überprüfen Sie die Zahlungsinformationen sorgfältig',
		odPay: 'Stornierung der Transaktion',
		tdCeil: 'Wenn Sie den Verkäufer bezahlt haben, bitte stornieren Sie die Transaktion nicht',
		pCeil: 'Bestätigung der Zahlung',
		paySure: 'Bitte bestätigen Sie, dass Sie den Verkäufer bezahlt haben',
		pdopay: 'Bösartige Klicks werden das Konto direkt einfrieren',
		badClick: 'Bestätigung der Sammlung',
		receivePay: 'Bitte bestätigen Sie, dass der Käufer Sie bezahlt hat',
		payReceive: 'Bestätigen Sie den Empfang',
		receivePays: '',
		// LegalPay
		payPlease: 'Bitte zahlen',
		tdPrice: 'Preis je Einheit',
		tdNum: 'Anzahl der Transaktionen',
		payinfo: 'Informationen zur Zahlung',
		banknum: 'Bankkonto und',
		realName: 'Real name',
		shoperZname: 'Unterzweig Merchant',
		shoperNum: 'Kaufmännisches Konto',
		odCeil: 'Stornierung der Bestellung',
		imPay: 'Ich habe bezahlt, klicken Sie OK',
		// LegalSeller
		register_time: 'Zeit der Registrierung',
		odtotal: 'Liste der Montage',
		odmonth: '30 Tagesbestellung',
		odfinish: 'Tabelle ausfüllen',
		odrate: 'Ergänzender Satz',
		submit: 'Freigabe',
		phone: 'Handy (Handy)',
		mysell: 'Mein Verkauf',
		mybuy: 'Mein Kauf',
		realAuth: 'Authentifizierung des realen Namens',
		advAuth: 'Erweiterte Zertifizierung',
		linebuy: 'Online kaufen',
		linesell: 'Online Verkauf',
		tipPay: 'Bitte kontaktieren Sie den Kaufmann zur Zahlung innerhalb von 24 Stunden. Überschreitet er 24-Stunden, wird er automatisch storniert',
		notlow: 'Nicht weniger als das Minimum',
		nothigh: 'Die Höchstgrenze kann nicht überschritten werden',
		notnum: 'Die Höchstmenge kann nicht überschritten werden',
		// LegalShopDetail
		type: 'Typ',
		status: 'Zustand',
		seeOrder: 'Reihenfolge der Ansicht',
		withdraw: 'Rückzug',
		abnormal: 'abnormal',
		lowershelf: 'Aus dem Regal',
		protection: 'Rechte der Verteidigung',
		apply: 'Antrag auf Rechtsschutz',
		psType: 'Bitte wählen Sie einen Typ',
		pselect: 'Bitte wählen',
		alipay: 'Alipay',
		wechat: 'WeChatGenericName',
		bank: 'Karte der Bank',
		minNum: 'Minimales Transaktionsvolumen',
		maxNum: 'Maximales Handelsvolumen',
		wantBuy: 'wollen kaufen',
		pnums: 'Bitte geben Sie die Menge',
		pmin: 'Bitte geben Sie das minimale Transaktionsvolumen ein',
		pmax: 'Bitte geben Sie das maximale Transaktionsvolumen ein',
		pnot: 'Das maximale Transaktionsvolumen darf nicht unter dem Mindestvolumen liegen.',
		// MyLegalShops
		myshops: 'persönliche Geschäfte',
		name: 'Name',
		fiatSub: 'Rechtliche Währung',
		shoper_balance: 'Handelsbilanzsaldo',
		enterShop: 'Geben Sie den Speicher ein',
		// shop_legal_pay_detail
		payedWait: 'Die Zahlung wurde vorgenommen und wartet auf Bestätigung nach Überprüfung',
		yes: 'ja',
		no: 'nein',
		sd: 'Waage sperren',
		journal: 'Logbuch der Bilanz',
		business: 'Geschäft',
		user: 'Benutzer',
		backdone: 'Zurückgezogen',
		busbalance: 'Handelsbilanzsaldo',
		userbalance: 'Die Benutzerbilanz',
	},
	ctc: {
		ctc: 'C2C',
		myRelease: 'I veröffentlichte C2C',
		myTrade: 'C2C meiner Transaktion',
		and: 'ja',
		balance: 'Bilanz',
		buynum: 'Volumen des Käufes',
		sellnum: 'Volumen der Verkäufe',
		bankTransfer: 'Überweisung der Bank',
		payim: 'Muss persönlich bezahlt werden',
		pbuyNum: 'Bitte geben Sie die Bestellmenge ein',
		pprice: 'Bitte Einheitspreis eingeben',
		payway: 'Bitte wählen Sie die Zahlungsmethode',
		psellNum: 'Bitte geben Sie die verkaufte Menge ein',
		suerePlace: 'Bestätigen Sie die Bestellung?',
		detail: 'Details',
		payinfo: 'Informationen zur Zahlung',
		Payee: 'Zahlungsempfänger',
		total: 'insgesamt',
		name: 'vollständiger Name',
		cardnum: 'Nummer der Karte',
		receivePay: 'Bestätigen Sie den Empfang',
		ceilConfirm: 'Bestätigen Sie die Stornierung der Transaktion？',
		paySeller: 'Bitte bestätigen Sie, dass Sie den Verkäufer bezahlt haben.',
		payBuyer: 'Bitte bestätigen Sie, dass Sie Home Payment Informationen gekauft haben',
		account: 'Nummer des Kontos',
		sellerPay: 'Bitte bestätigen Sie, dass der Käufer Sie bezahlt hat？',
		payattion: 'Bitte zahlen Sie so schnell wie möglich nach Zahlungsbestätigung an den Verkäufer. Bösartiges Klicken wird das Konto direkt einfrieren',
		log: 'C2C ausgefüllter Auftrag',
	},
	// 合约
	lever: {
		purchase: "Der Kaufpreis",
		Expected: "Geschätzte Gewinne und Verluste",
		countdown: "Countdown",
		second: "Sekunde",
		jiaoyinum: "Anzahl",
		houmaicg: "Kaufen erfolgreich",
		nowentrust: 'Aktuelle Delegation',
		hisentrust: 'Historische Beauftragung',
		lvchi: 'Position des Vertrags',
		all: 'ganze',
		or: 'oder',
		gotrade: 'Beginn des Handels',
		tdrecord: 'Datensatz der Transaktion',
		dealed: 'Geschlossen',
		notdeal: 'Kein Deal.',
		loading: 'Laden...',
		entotal: 'Gesamtbetrag der anvertrauten Mittel',
		canuse: 'verfügbar',
		std: 'Handel mit Marktpreisen',
		xtd: 'Grenzüberschreitender Handel',
		pprice: 'Bitte Preis eingeben',
		phand: 'Bitte geben Sie die Bestellmenge ein',
		phandsell: 'Bitte geben Sie die Verkaufsmenge ein',
		pwd: 'Passwort',
		ppwd: 'Bitte geben Sie das Transaktionspasswort ein',
		psw: 'Passwort der Transaktion',
		equal: 'gleich zu sein',
		times: 'Zeiten',
		timed: 'mehrere',
		hand: 'Hand',
		miao: 's',
		miaos: 'Sekunden',
		hands: 'Anzahl der Hände',
		ptimes: 'Bitte mehrere auswählen',
		phands: 'Bitte wählen Sie die Anzahl der Hände',
		contractVal: 'Marktwert des Vertrags',
		bail: 'Bindung',
		canBail: 'Freie Marge',
		charge: 'Gebühr für Transaktionsdienste',
		domore: 'Kaufen (lange)',
		doshort: 'Verkauf (kurz)',
		dmore: 'Tu mehr',
		dshort: 'Kurze',
		sureOd: 'Bestellung bestätigen',
		noless: 'Die Anzahl der Hände kann nicht geringer sein als',
		nomore: 'Die Anzahl der Hände kann nicht höher sein als',
		tdnum: 'Volumen des Handels',
		risk: 'Risiko rate',
		allloss: 'Gewinn und Verlust insgesamt',
		onehouse: 'Mit einem Klick Position schließen',
		type: 'Typ',
		entrustPrice: 'Preis der Kommission',
		openPrice: 'Preis der Eröffnung',
		nowPrice: 'Aktueller Preis',
		styPrice: 'Stoppen des Gewinns',
		stsPrice: 'Anhalten des Verlustpreises',
		openTime: 'Open Time',
		closeTime: 'Zeit zum Schließen',
		rate: 'Service berechnen',
		nightFee: 'Gebühr über Nacht',
		loss: 'Gewinn und Verlust',
		setloss: 'Gewinn- und Verluststopp setzen',
		expectProfit: 'Erwartete Gewinne',
		expectLoss: 'Erwartete Verluste',
		allClose: 'Alle Positionen schließen',
		moreClose: 'Nur flache Mehrfachbestellungen',
		nullClose: 'Nur leere Aufträge',
		sureClose: 'Bestätigen Schließen？',
		thanZearo: 'Der Wert set muss größer sein als 0',
		listin: 'Bis zur Bestellung',
		tdin: 'In Transaktion',
		closein: 'Position schließen',
		closed: 'Geschlossene Position',
		revoked: 'aufgehoben',
		revokeOrder: 'Sind Sie sicher, die Bestellung zu stornieren？',
		ping: 'eine Position schließen',
		revoke: 'Stornieren Sie die Bestellung',
		sureping: 'Bestätigen Sie die Endposition？',
		thanzone: 'Der Wert set muss größer sein als 0',

		profitability: 'Rentabilität',
		profit_: 'Profitieren',
	},
	// 币币
	cuy: {
		direction: 'Richtung',
		total: 'insgesamt',
		price: 'Preis',
		sell: 'verkaufen',
		buy: 'kaufen',
		allStation: 'Gesamte Stationstransaktion',
		buyPrice: 'Der Kaufpreis',
		buynum: 'Volumen des Käufes',
		sellPrice: 'Verkaufspreis',
		sellnum: 'Volumen der Verkäufe',
		tdPrice: 'ein Umsatz',
		or: 'oder',
		tdStart: 'Beginn des Handels',
		pbPrice: 'Bitte den Kaufpreis eingeben',
		pbNum: 'Bitte geben Sie die Bestellmenge ein',
		psPrice: 'Bitte geben Sie den Verkaufspreis ein',
		psNum: 'Bitte geben Sie das Verkaufsvolumen ein',
		fixPrice: 'Grenzüberschreitender Handel',
		Mtrans: 'Handel mit Marktpreisen',
		available: 'verfügbar',
		revoke: 'Widerruf',
		loading: 'Laden',
		confirmCancel: 'Bist du sicher, dass du absagen willst?？',
		confirm: 'bestimmen',
		cancel: 'Stornieren',
		nomore: 'Keine Daten mehr',
		evelPrice: 'Durchschnittlicher Transaktionspreis'
	},
	// 资产
	asset: {
		text1:'Adresse laden',
		text2:'Bitte geben Sie die Ladeadresse ein',
		text3:'Menge der Chargen',
		text4:'Bitte geben Sie die Lademenge ein',
		text5:'Informationen zum Laden einreichen',
		miao_account: 'Benutzerkonto für Geschwindigkeitsvertragungen',
		assets: 'Aktiva',
		currency_account: 'Konto in Währung',
		lever_account: 'Konto des Vertrags',
		fince_account: 'Rechtliches Währungskonto',
		change_account: 'Das Handelskonto',
		assets_hua: 'Übertragung des Fonds',
		all_assets: 'Umwandlung der Aktiva insgesamt',
		currency: 'Währung',
		canuse: 'verfügbar',
		frezz: 'gefroren',
		conversion: 'Gleichwertige',
		charging: 'Geld verlangen',
		withdraw: 'Zurückziehen des Geldes',
		address_bind: 'Bindende Rücknahmeadresse',
		address_withdraw: 'Verwaltung der Anschrift',
		record: 'Datensatz',
		address_charge: 'Adresse laden',
		address_width: 'Anschrift der Rücknahme',
		copy: 'Kopie',
		ercode: 'QR Code',
		reminder: 'Erinnerung',
		notcharge: 'Laden Sie keine Nicht-USDT-Vermögenswerte an die oben genannte Adresse auf, da die Vermögenswerte sonst nicht abgerufen werden',
		support: 'Das Laden unterstützt nur die einfache Sende-Methode. Das Laden mit anderen Methoden (senden Sie alle) kann nicht vorübergehend aufgezeichnet werden. Bitte verstehen Sie das.',
		minnum: 'Minimale Rücknahmemenge',
		ratenum: 'Service berechnen',
		havenum: 'Erhaltene Menge',
		from: 'von',
		to: 'zu',
		transfer: 'Übertragung',
		tfnum: 'Menge der Übertragung',
		ptfnum: 'Bitte geben Sie ein Minimum',
		dtfnum: 'Anzahl der Transfers',
		canbalance: 'Verfügbarer Saldo',
		sureConfirm: 'Bestätigen der Übertragung',
		moneyRecord: 'Finanzielle Aufzeichnungen',
		pNum: 'Bitte geben Sie die Transfermenge ein',
		leverUse: 'Verfügbares Vertragskonto',
		legalUse: 'Rechtliches Währungskonto verfügbar',
		changeUse: 'Verfügbares Transaktionskonto',
		look: 'siehe',
		chargeRecord: 'Aufzeichnung laden',
		status: 'Status der Strecke',
		noopen: 'Diese Funktion ist noch nicht geöffnet',
		enterAdderses: 'Bitte geben Sie die Rücknahmeadresse ein',
		enterNum: 'Bitte geben Sie die Widerrufsmenge ein',
		lessMin: 'Die in der Währung eingegebene Rücknahmemenge ist geringer als der Mindestwert',
		tips01: 'Laden Sie keine anderen Vermögenswerte auf die oben genannte Adresse, sonst werden die Vermögenswerte nicht zurückgefordert.',
		tips02: 'Das Laden unterstützt nur die einfache Sende-Methode. Laden mit anderen Methoden (senden Sie alle) kann nicht vorübergehend aufgeladen werden. Bitte verstehen Sie das.',
		beizhu: 'Bemerkungen',
		pbeizhu: 'Bitte Kommentare eingeben',
		add: 'hinzufügen zu',
		addressList: 'Liste der Adressen',
		delete: 'Löschen',
		norec: 'Kein Eintrag',
		selectCurrency: 'Bitte wählen Sie eine Währung',
		chainType: "Art der Kette"
	},
	// 账户设置
	set: {
		mycode2: 'Mein Autorisierungscode',
		copycode2: 'Kopiercode der Autorisierung',
		uaccont: 'Ihre Kontosicherheit:',
		strong: 'stark',
		middle: 'in',
		weak: 'schwach',
		min: 'niedrig',
		heigh: 'hoch',
		complete: 'Weitere Informationen zur Gewährleistung der Kontosicherheit verbessern',
		mycode: 'Mein Einladungscode',
		copycode: 'Code kopieren',
		bindphone: 'Verbindendes Mobiltelefon',
		bindemail: 'Bind Mailbox',
		loginpwd: 'Passwort einloggen',
		noBind: 'Ungebunden',
		binds: 'Bindung',
		bind: 'Entnahme',
		binded: 'Abgebunden',
		net: 'Es besteht die Gefahr eines Diebstahls Ihres Internetkontos. Es wird empfohlen, Ihr Passwort regelmäßig zu ändern, um die Sicherheit Ihres Kontos zu schützen.',
		reset: 'ändern',
		setPsw: 'Setzen Sie das Transaktionspasswort, um die Transaktionssicherheit zu gewährleisten.',
		goSet: 'Zu setzen',
		bindAccount: 'Bind exchange account',
		duihuan: 'Bind account to exchange points',
		copysuccess: 'Kopieren erfolgreich',
		copyfail: 'Kopieren fehlgeschlagen',
		recopy: 'Bitte nochmal kopieren',
		account: 'Konto',
		detail: 'Details',
		val: 'Betrag des Geldes',
		forgetPsw: 'Passwort vergessen',
		code: 'Code der Überprüfung',
		getCode: 'Verifikationscode erhalten',
		setPsw: 'Passwort setzen',
		enterPsw: 'Bitte geben Sie ein Passwort ein',
		pswFalse: 'Die zweimal eingegebenen Passwörter sind inkonsistent',
		enterPswagain: 'Bitte geben Sie das Passwort erneut ein',
		jsetPsw: 'Passwort festlegen',
		jenterPsw: 'Bitte geben Sie das Transaktionspasswort ein',
		jenterPswagain: 'Bitte geben Sie das Transaktionspasswort erneut ein',
		enterAccount: 'Bitte geben Sie die Kontonummer ein',
		enterCode: 'Bitte geben Sie den Verifizierungscode ein',
		accountFalse: 'Das von Ihnen eingegebene Handy- oder E-Mail-Konto entspricht nicht den Regeln!',
		second: 'Sekunde',
		sendCode: 'Senden Sie den Verifizierungscode',
		sendsucc: 'Gesendet erfolgreich',
		enterPswTwo: 'Bitte geben Sie Ihr Passwort zweimal ein',
		rest: 'Überschuss',
		yes: 'ja',
		no: 'nein',
		yorn: 'Passwort festlegen',
	},
	// 身份认证
	auth: {
		identity: 'Authentifizierung der Identität',
		name: 'vollständiger Name',
		idcard: 'ID',
		upimg: 'Bitte laden Sie Ihr ID-Foto hoch. Das erste ist die Vorderseite, das zweite die Rückseite, und das dritte ist die Vorderseite Ihres HandID-Fotos.Senden。',
		submit: 'Gegenstand der Überprüfung',
		auditing: 'Zertifiziert...',
		certified: 'Bitte geben Sie Ihren Namen ein!',
		pname: 'Bitte geben Sie die ID-Nummer ein',
		pidcard: 'Bitte laden Sie Ihr ID-Bild hoch',
		pimg: '!',
	},
	// 收款方式
	seting: {
		pmethod: 'Methode der Zahlung',
		truename: 'Real name',
		opening: 'Name der Deponiebank',
		bank: 'Bankkarte Nr.',
		alipay: 'Konto Alipay',
		wename: 'Spitzname von Wechat',
		wechat: 'Konto Wechat',
		pname: 'Bitte geben Sie Ihren richtigen Namen ein',
		popen: 'Bitte geben Sie den Namen der Bank ein',
		pcard: 'Bitte geben Sie die Bankkartennummer ein',
		palipay: 'Bitte geben Sie die Alipay-Kontonummer ein',
		pwname: 'Bitte geben Sie den Namen wechat ein',
		pwaccount: 'Bitte geben Sie wechat ein',
		pimg1: 'Code der Sammlung Wechat',
		pimg2: 'Alipay collection code'
	},
	// 帮助中心
	news: {
		seeall: 'Alle anzeigen',
		helpcenter: 'Hilfe Center',
		back: 'zurück',
		gonggao: 'Mitteilung'
	},
	//登录
	login: {
		welcome: 'Willkommen beim Login',
		phoneLogin: 'Mobile Anmeldung',
		emailLogin: 'Anmeldung per E-Mail',
		account: 'Nummer des Kontos',
		psw: 'Passwort',
		login: 'Melden Sie sich',
		nouser: 'Noch kein Azbit-usa Benutzer?',
		goRegister: 'Registrieren Sie sich jetzt und beginnen Sie mit dem Handel mit der weltweit führenden digitalen Asset-Trading-Plattform.',
		registerFree: 'Kostenlose Registrierung',
		psw6: 'Das Passwort kann nicht weniger als sechs Ziffern sein'
	},
	register: {
		register: 'Register',
		phoneRegister: 'Mobile Registrierung',
		emailRegister: 'Registrierung der Mailbox',
		country: 'Nationalität',
		enterPhone: 'Bitte geben Sie Ihre Mobiltelefonnummer ein',
		enterEmail: 'Bitte E-Mail-Adresse eingeben',
		psw16: 'Das Passwort ist zwischen 6-16 Bits',
		inviteCode: 'Code der Einladung',
		sel: 'Erforderlich',
		sel2: 'Nicht erforderlich',
		read: 'Ich habe gelesen und stimme zu',
		xieyi: '《Zustimmung des Benutzers》',
		tips01: 'Die Nationalitätsinformationen können nach der Registrierung nicht geändert werden. Bitte wählen Sie sie wahrheitsgemäß aus.',
		tips02: 'Bestätigungsmail kann als Spam falsch eingeschätzt werden. Bitte überprüfen Sie es.',
		tips03: 'Bitte halten Sie Ihr Azbit-usa-Konto und Login-Passwort richtig.',
		tips04: 'Verwenden Sie nicht das gleiche Login-Passwort wie andere Websites.',
		emailFalse: 'Die Mailbox, die Sie eingegeben haben, entspricht nicht den Regeln'
	},
	// 积分兑换
	jc: {
		title: 'JC tauscht digitale Vermögenswerte für eine Plattform aus',
		balance: 'Bilanz',
		cannum: 'Anzahl der verfügbaren JCS',
		new: 'Aktuelle Preise',
		exnum: 'Menge der Wechselkurse',
		pnum: 'Bitte geben Sie die JC-Menge ein',
		canex: 'Anzahl der konvertiblen beau',
		exnow: 'Jetzt erlösen',
		record: 'Exchange Record',
		exprice: 'Der Wechselkurs',
		extime: 'Zeit des Austauschs',
		not: 'Zu wenig verfügbare Punkte',
		usenum: 'Anzahl der verwendeten JCS',
		out: 'Sign out',
		gotd: 'Zum Handel'

	}

}



// WEBPACK FOOTER //
// ./src/lang/de.js